<template>
    <div class="apn-page apn-coming-soon">
        <div class="centered">
            <h1>Customer Portal Coming Soon...</h1>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.apn-coming-soon {
    padding: 40px 0;
    height: 100vh;
 
    .centered {
        height: 100%;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        h1 {
            text-transform: uppercase;
            font-size: 1rem;
            font-weight: bold;
            text-align: center;
            padding: 40px 0 20px;
            color: var(--primary);
            @media (min-width: 992px) {
                font-size: 2.5rem;
            }
        }

    }
}

</style>